"use dom";

type ContentRendererProps = Readonly<{
  content: string;
  primaryColor?: string;
  textColor?: string;
  borderColor?: string;
  containerBg?: string;
  dom?: import("expo/dom").DOMProps;
}>;

export default function ContentRenderer({
  content,
  primaryColor = "#0669B3",
  textColor = "#22272a",
  borderColor = "#DFE5EC",
  containerBg = "#FFFFFF",
}: ContentRendererProps) {
  const cleanedContent = content.replace(/color\s*:\s*[^;}"']+;?/gi, "");

  const html = `<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8"/>
  <meta name="viewport" content="width=device-width, initial-scale=1.0"/>
  <link href="https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap" rel="stylesheet"/>
  <style>
    * { box-sizing: border-box; margin: 0; padding: 0; }
    html, body {
      background-color: ${containerBg};
      font-family: 'Inter', sans-serif;
      font-size: 15px;
      line-height: 1.6;
      color: ${textColor};
      padding: 0;
      margin: 0;
    }
    .ql-content { color: ${textColor}; background-color: ${containerBg}; }
    .ql-content p { margin: 0 0 0.75em 0; color: ${textColor}; }
    .ql-content h1 { font-size: 2em; font-weight: 600; margin: 0.5em 0; color: ${textColor}; }
    .ql-content h2 { font-size: 1.5em; font-weight: 600; margin: 0.5em 0; color: ${textColor}; }
    .ql-content h3 { font-size: 1.2em; font-weight: 600; margin: 0.5em 0; color: ${textColor}; }
    .ql-content span { color: ${textColor}; }
    .ql-content strong { font-weight: 600; color: ${textColor}; }
    .ql-content em { font-style: italic; color: ${textColor}; }
    .ql-content a { color: ${primaryColor}; text-decoration: underline; }
    .ql-content ol, .ql-content ul { padding-left: 1.5em; margin: 0 0 0.75em 0; }
    .ql-content ul { list-style-type: disc; }
    .ql-content ol { list-style-type: decimal; }
    .ql-content li { margin-bottom: 0.25em; display: list-item; color: ${textColor}; }
    .ql-content li[data-list="bullet"] { list-style-type: disc; }
    .ql-content li[data-list="ordered"] { list-style-type: decimal; }
    .ql-content .ql-ui { display: none; }
    .ql-content .ql-align-center { text-align: center; }
    .ql-content .ql-align-right { text-align: right; }
    .ql-content .ql-indent-1 { padding-left: 3em; }
    .ql-content .ql-indent-2 { padding-left: 6em; }
    .ql-content .ql-indent-3 { padding-left: 9em; }
    .ql-content blockquote {
      border-left: 4px solid ${borderColor};
      padding-left: 1em;
      margin: 0 0 0.75em 0;
      color: ${textColor};
      opacity: 0.75;
    }
  </style>
</head>
<body>
  <div class="ql-content">${cleanedContent}</div>
</body>
</html>`;

  return (
    <div
      style={{ all: "unset", display: "block" }}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
